import { AdminHyperlinkModule } from '@app/main/admin/modules/admin-hyperlink/admin-hyperlink.module';
import { AdminFaqModule } from '@app/main/admin/modules/admin-faq/admin-faq.module';
import { AdminComponent } from '@app/main/admin/admin.component';
import { CommonModule } from '@angular/common';
import { AdminResponsibleModule } from '@app/main/admin/modules/admin-responsible/admin-responsible.module';
import { AdminReportModule } from '@app/main/admin/modules/admin-report/admin-report.module';
import { NgModule } from '@angular/core';
import {
    AdminElementsComponent,
    AdminSidebarComponent,
    AdminToolbarComponent,
    AdminToolbarFaqComponent,
    AdminToolbarGlossaryComponent,
    AdminToolbarHyperlinkComponent,
    AdminToolbarReportComponent,
    AdminToolbarResponsibleComponent,
    AdminToolbarUserComponent
} from '@app/main/admin/components';
import { SharedModule } from '@shared/shared.module';
import { AdminUsersModule } from '@app/main/admin/modules/admin-users/admin-users.module';
import { AdminGlossaryModule } from '@app/main/admin/modules/admin-glossary/admin-glossary.module';
import { AdminRoutingModule } from '@app/main/admin/admin-routing.module';
import { AdminReportTemplateModule } from './modules/admin-report-template/admin-report-template.module';

@NgModule({
    declarations: [
        AdminComponent,
        AdminElementsComponent,
        AdminSidebarComponent,
        AdminToolbarComponent,
        AdminToolbarFaqComponent,
        AdminToolbarUserComponent,
        AdminToolbarResponsibleComponent,
        AdminToolbarHyperlinkComponent,
        AdminToolbarGlossaryComponent,
        AdminToolbarReportComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        AdminRoutingModule,
        AdminUsersModule,
        AdminFaqModule,
        AdminResponsibleModule,
        AdminHyperlinkModule,
        AdminGlossaryModule,
        AdminReportModule,
        AdminReportTemplateModule
    ]
})
export class AdminModule {}
